import { TOGGLE_MENU, CLOSE_MENU } from "../actionTypes";
export const toggleMenu = () => ({
  type: TOGGLE_MENU,
});

export const closeMenu = () => ({
  type: CLOSE_MENU,
});
